/**
 * LTI Enroll Exam
 * LTI Enroll Exam for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';

/**
* Downloads service.
* @module api/DownloadsApi
* @version 2.0.0
*/
export default class DownloadsApi {

    /**
    * Constructs a new DownloadsApi. 
    * @alias module:api/DownloadsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * download exam attendance certificate
     * @param {String} email 
     * @param {Object} opts Optional parameters
     * @param {String} opts.academicSection 
     * @param {String} opts.lang 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
    examControllerGetExamCertificateWithHttpInfo(email, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'email' is set
      if (email === undefined || email === null) {
        throw new Error("Missing the required parameter 'email' when calling examControllerGetExamCertificate");
      }

      let pathParams = {
        'email': email
      };
      let queryParams = {
        'academic_section': opts['academicSection'],
        'lang': opts['lang']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/lti/enrollExam/students/{email}/exam-certificate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * download exam attendance certificate
     * @param {String} email 
     * @param {Object} opts Optional parameters
     * @param {String} opts.academicSection 
     * @param {String} opts.lang 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
    examControllerGetExamCertificate(email, opts) {
      return this.examControllerGetExamCertificateWithHttpInfo(email, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * download exam join certificate
     * @param {String} email 
     * @param {Object} opts Optional parameters
     * @param {String} opts.academicSection 
     * @param {String} opts.lang 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
    examControllerGetExamJoinCertificatesWithHttpInfo(email, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'email' is set
      if (email === undefined || email === null) {
        throw new Error("Missing the required parameter 'email' when calling examControllerGetExamJoinCertificates");
      }

      let pathParams = {
        'email': email
      };
      let queryParams = {
        'academic_section': opts['academicSection'],
        'lang': opts['lang']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/lti/enrollExam/students/{email}/joined-certificate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * download exam join certificate
     * @param {String} email 
     * @param {Object} opts Optional parameters
     * @param {String} opts.academicSection 
     * @param {String} opts.lang 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
    examControllerGetExamJoinCertificates(email, opts) {
      return this.examControllerGetExamJoinCertificatesWithHttpInfo(email, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
